// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1d3Ei","tab":"ProcedureTabs_tab__3Xvyh"};